/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { NotificationCounts } from './NotificationCounts'
import {
  NotificationCountsFromJSON,
  NotificationCountsFromJSONTyped,
  NotificationCountsToJSON,
} from './NotificationCounts'
import type { UserNotification } from './UserNotification'
import {
  UserNotificationFromJSON,
  UserNotificationFromJSONTyped,
  UserNotificationToJSON,
} from './UserNotification'
import type { SitePagination } from './SitePagination'
import {
  SitePaginationFromJSON,
  SitePaginationFromJSONTyped,
  SitePaginationToJSON,
} from './SitePagination'

/**
 *
 * @export
 * @interface GetUserNotifications200Response
 */
export interface GetUserNotifications200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetUserNotifications200Response
   */
  status: boolean
  /**
   *
   * @type {Array<UserNotification>}
   * @memberof GetUserNotifications200Response
   */
  data: Array<UserNotification>
  /**
   *
   * @type {SitePagination}
   * @memberof GetUserNotifications200Response
   */
  pagination: SitePagination
  /**
   *
   * @type {NotificationCounts}
   * @memberof GetUserNotifications200Response
   */
  meta: NotificationCounts
}

/**
 * Check if a given object implements the GetUserNotifications200Response interface.
 */
export function instanceOfGetUserNotifications200Response(
  value: object
): value is GetUserNotifications200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  if (!('pagination' in value) || value['pagination'] === undefined)
    return false
  if (!('meta' in value) || value['meta'] === undefined) return false
  return true
}

export function GetUserNotifications200ResponseFromJSON(
  json: any
): GetUserNotifications200Response {
  return GetUserNotifications200ResponseFromJSONTyped(json, false)
}

export function GetUserNotifications200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUserNotifications200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(UserNotificationFromJSON),
    pagination: SitePaginationFromJSON(json['pagination']),
    meta: NotificationCountsFromJSON(json['meta']),
  }
}

export function GetUserNotifications200ResponseToJSON(
  value?: GetUserNotifications200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(UserNotificationToJSON),
    pagination: SitePaginationToJSON(value['pagination']),
    meta: NotificationCountsToJSON(value['meta']),
  }
}
